module.exports = __webpack_public_path__ + "static/media/kizuna-logo.d5f195a6.png";